import Backbone from 'backbone';
import _ from 'underscore';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import { getBidAdjustmentOptions, computeBidAdjustment, isBidAdjustmentValid, getValidationError } from './bid-adjustment-utils';
import template from './bid-adjustment.pug';

export class BidAdjustmentControlView extends Backbone.View {
  initialize(options = {}) {
    this.i18n = DependencyResolver.get('component/i18n/loader!campaignui/feature/audience-campaign');
    this.criterionType = options.criterionType;
    this.bidAdjustmentOptions = _.defaults(
      options.bidAdjustmentOptions || {},
      getBidAdjustmentOptions()
    );

    // Set inital state to valid
    this.isValid = true;
  }

  get events() {
    return {
      'change input': e => this.handleBidAdjustmentChange(e),
      'change select': e => this.handleBidAdjustmentChange(e),
    };
  }

  /**
    * Event handler for bid adjustment change
    * @private
    *
    * @returns {Promise} - Promise of handling bid adjustment change
    */
  handleBidAdjustmentChange() {
    this.$('.error').empty();

    this.isValid = true;

    // Validate bid adjustment
    const bidAdjValue = this.getBidAdjustmentValue();

    if (!isBidAdjustmentValid(bidAdjValue, this.criterionType)) {
      this.$('.error').text(getValidationError(bidAdjValue, this.criterionType));
      this.isValid = false;
    }
  }

  /**
  * Check if the control is in a valid state
  *
  * @returns {boolean} current state
  */
  validate() {
    return this.isValid;
  }

  getBidAdjustmentValue() {
    const bidAdjPercentage = this.$('input').val();
    const bidAdjOption = this.$('select').val();

    const bidAdjValue = computeBidAdjustment(bidAdjPercentage, bidAdjOption);

    return bidAdjValue;
  }

  /**
   * Renders the view
   *
   * @returns {View} returns the view itself
   */
  render() {
    this.$el.html(template(_.extend(this.bidAdjustmentOptions, { size: 5, i18n: this.i18n })));

    return this;
  }
}
